import superagent from 'superagent';
import { getUserToken } from 'utils/authHeader';
import { unauthorizedRedirect } from 'utils/unauthorizedRedirect';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const listFaq = async () => {
  return await superagent
    .get(`${BASE_URL}/faq/list`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .use(unauthorizedRedirect)
    .retry(2);
};

export const addFaq = async (payload) => {
  return await superagent
    .post(`${BASE_URL}/faq/create`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .use(unauthorizedRedirect)
    .send(payload)
    .retry(2);
};

export const editFaq = async (payload) => {
  return await superagent
    .put(`${BASE_URL}/faq/edit`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .use(unauthorizedRedirect)
    .send(payload)
    .retry(2);
};
export const deleteFaq = async (faqid) => {
  return await superagent
    .delete(`${BASE_URL}/faq/delete`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .send({ faqid })
    .retry(2);
};
